// ============================================
//  TOP MVアニメーション
// ============================================
function mv() {
  const mv = document.querySelectorAll('.js-mv');

  mv.forEach((element) => {
    let topWrap, topTitle, wrapHeight;
    let isActive = false;

    function updateElements() {
      topWrap = element.querySelector('.js-mv__titleWrap');
      topTitle = element.querySelector('.js-mv__title');
      wrapHeight = topWrap?.offsetHeight || 0;
    }

    function onScroll() {
      if (!isActive || !topTitle) return;
      const scrollY = window.scrollY;
      const moveY = Math.min(scrollY, wrapHeight);
      topTitle.style.transform = `translateY(${moveY}px)`;
    }

    function enable() {
      if (isActive) return;
      updateElements();
      if (!topWrap || !topTitle) return;
      isActive = true;
      window.addEventListener('scroll', onScroll);
      onScroll(); // ← 初期化時に1回実行
    }

    function disable() {
      if (!isActive) return;
      isActive = false;
      window.removeEventListener('scroll', onScroll);
      if (topTitle) topTitle.style.transform = 'translateY(0px)';
    }

    function handleResize() {
      updateElements();

      if (window.innerWidth > 1024) {
        enable();
      } else {
        disable();
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  });
}

export { mv };
